export default __webpack_public_path__ + "static/media/Rectangle 385.7520f659.png";